// Checkout currency from the visitor's IP country: Canada pays in CAD, every
// other country (or a failed lookup) falls back to USD. The backend makes the
// final call and also falls back to USD when a price has no CAD option.
//
// Looked up once per page load, so the plan screen and the checkout it opens
// always agree on the currency.
import axios from "axios";

let pending = null;

export const detectCheckoutCurrency = () => {
  if (!pending) {
    pending = axios
      .get("https://ipinfo.io/json", { timeout: 4000 })
      .then((res) => (res.data?.country === "CA" ? "cad" : "usd"))
      .catch(() => "usd");
  }
  return pending;
};

export const currencySymbol = (currency) => (currency === "cad" ? "CA$" : "$");
